import { useEffect } from 'react';
import { Auth } from 'aws-amplify';
import { useNavigate } from 'react-router-dom';

import { logger } from 'utils/logger';
import { OktaExternalAuth } from 'utils/okta/OktaExternalAuthService';
import { OktaInternalAuth } from 'utils/okta/OktaInternalAuthService';
import { AuthTokenType } from './types';
import { getAuthTokenTypeLocalStorage } from 'Lib/Utils/authToken';

const UserSignOut = () => {
    const tokenType = getAuthTokenTypeLocalStorage();
    const history = useNavigate();

    useEffect(() => {
        switch (tokenType) {
            case AuthTokenType.OktaExternal:
                OktaExternalAuth.getInstance()
                    .then((instance) => instance.signOut())
                    .catch((error) => {
                        logger.error(error);
                    });
                break;
            case AuthTokenType.OktaInternal:
                OktaInternalAuth.getInstance()
                    .then((instance) => instance.signOut())
                    .catch((error) => {
                        logger.error(error);
                    });
                break;
            default:
                const doPostSignOutActions = () => {
                    const view = localStorage.getItem('paymentsView');
                    sessionStorage.clear();
                    localStorage.clear();
                    localStorage.setItem('paymentsView', view);
                    history('/signin?source=signout', { replace: true });
                };

                Auth.signOut()
                    .then(doPostSignOutActions)
                    .catch((err) => {
                        console.log('user is already signed in, redirecting back to home', err);
                        history('/', { replace: true });
                    });
                break;
        }
    }, [tokenType]);

    return null;
};

export default UserSignOut;
